(function () {
  // Never calls BoosterTheme.cart.addToCartJSON: its success() branch is what
  // fires Booster's upsell/redirect screen. Adds here go through a raw fetch
  // to the Ajax cart endpoints instead, so that branch never runs.
  //
  // 2026-08-14: the size control and the size ladder helpers moved out to
  // assets/ch-cart-size.js, loaded immediately before this file. This file now
  // owns only the rack: which products appear, the tile markup, and the cart
  // add/change calls. Splitting them keeps both files under the size at which
  // Admin API writes stop being reliable.
  var TILE_LIMIT = 4;
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  var CHS = window.CHCartSize;

  function esc(s) { return CHS.escapeHtml(s); }

  var state = {
    ranked: null,
    productsById: {},
    addedProductIds: {},
    cartEmpty: true
  };

  function getRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // BoosterTheme is a bare top-level const in booster.min.js, not window.BoosterTheme.
  function getBoosterTheme() {
    return typeof BoosterTheme !== 'undefined' ? BoosterTheme : null;
  }

  function getWrappers() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-cart-quickadd]'));
  }

  function getProductListEls() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-product-list]'));
  }

  function getMinicartInputs() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-minicart-input]'));
  }

  function anyDrawerOpen() {
    return getMinicartInputs().some(function (el) { return el.checked; });
  }

  function formatMoney(cents) {
    var n = typeof cents === 'number' ? cents : parseFloat(cents) || 0;
    return '$' + (n / 100).toFixed(2);
  }

  async function fetchCart() {
    try {
      var res = await fetch(getRoot() + 'cart.js', { headers: { 'Cache-Control': 'no-cache' } });
      if (!res.ok) return null;
      return await res.json();
    } catch (e) {
      return null;
    }
  }

  async function fetchRecommendations(productId) {
    try {
      // 'complementary' returns zero results on this store; 'related' has live data.
      var url = getRoot() + 'recommendations/products.json?product_id=' + productId + '&limit=6&intent=related';
      var res = await fetch(url, { headers: { 'Cache-Control': 'no-cache' } });
      if (!res.ok) return [];
      var data = await res.json();
      return data.products || [];
    } catch (e) {
      return [];
    }
  }

  // Booster patches window.fetch/XHR.open by URL pathname (cart/add.js etc)
  // regardless of caller, and any hit re-fetches the whole minicart section
  // and wipes [data-product-list], including this rack. Suppress for exactly
  // the duration of fn(); native remove/qty controls never call this.
  function withBoosterSuppressed(fn) {
    var booster = getBoosterTheme();
    var cart = booster && booster.cart;
    var original = cart && typeof cart.dispatchListeners === 'function' ? cart.dispatchListeners : null;
    if (cart && original) {
      cart.dispatchListeners = function () { return Promise.resolve(); };
    }
    function restore() {
      if (cart && original) { cart.dispatchListeners = original; }
    }
    return fn().then(
      function (result) { restore(); return result; },
      function (err) { restore(); throw err; }
    );
  }

  async function postJSON(path, body) {
    var res = await fetch(getRoot() + path, {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify(body)
    });
    var data = null;
    try { data = await res.json(); } catch (e) {}
    if (!res.ok) {
      var err = new Error((data && data.description) || 'Cart request failed');
      err.data = data;
      throw err;
    }
    return data;
  }

  // api__minicart.liquid breaks its own div nesting on purpose; .innerText
  // on a detached div holding the wrapped response strips every tag, JSON left.
  async function fetchSectionData() {
    try {
      var res = await fetch(getRoot() + '?section_id=api__minicart', {
        headers: { Pragma: 'no-cache', 'Cache-Control': 'no-cache' }
      });
      if (!res.ok) return null;
      var text = await res.text();
      var holder = document.createElement('div');
      holder.innerHTML = text;
      return JSON.parse(holder.innerText || holder.textContent);
    } catch (e) {
      return null;
    }
  }

  // Pulls fresh line items + shipping/total after our own add/size change; rack untouched.
  async function patchFromSection() {
    var data = await fetchSectionData();
    if (!data || typeof data.html !== 'string') return;
    var fresh = document.createElement('div');
    fresh.innerHTML = data.html;
    var freshLines = fresh.querySelector('[data-cart-lines]');
    var freshBottom = fresh.querySelector('.minicart__bottom');

    getProductListEls().forEach(function (holder) {
      if (freshLines) {
        var lines = holder.querySelector('[data-cart-lines]');
        if (lines) {
          lines.innerHTML = freshLines.innerHTML;
          wireLineSizeSelects(lines);
        }
      }
      var bottom = holder.querySelector('.minicart__bottom');
      if (freshBottom && bottom) {
        bottom.innerHTML = freshBottom.innerHTML;
      }
    });

    updateCountBadges(data.item_count);
  }

  function updateCountBadges(count) {
    Array.prototype.slice.call(document.querySelectorAll('[data-count]')).forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function renderTile(product, added) {
    var inStock = CHS.availableSizedVariants(product);
    if (!inStock.length) return '';
    var sized = CHS.allSizedVariants(product);
    var image = esc(product.featured_image || (product.images && product.images[0]) || '');
    var url = esc(product.url || '');
    var title = esc(product.title || '');
    var price = inStock[0].variant.price != null ? inStock[0].variant.price : product.price;
    var disabledAttr = added ? ' disabled' : '';

    // Preselect the first IN STOCK size so the + button always has a valid target.
    var preselectId = String(inStock[0].variant.id);
    var preselectLabel = CHS.entryLabel(inStock[0]);

    // Once added, the whole control is disabled rather than each option, so the
    // only disabled options are the genuinely sold out ones.
    var szHtml = CHS.menuHtml(sized, preselectId, preselectLabel, 'Size for ' + (product.title || ''), added);

    var addedClass = added ? ' is-added' : '';
    var btnText = added ? 'ADDED' : '+';

    return (
      '<div class="minicart__quickadd--tile' + addedClass + '" data-product-id="' + esc(String(product.id)) + '" data-selected-variant-id="' + esc(preselectId) + '">' +
        '<a class="minicart__quickadd--img" href="' + url + '" tabindex="-1">' +
          '<img src="' + image + '" alt="' + title + '" loading="lazy">' +
        '</a>' +
        '<div class="minicart__quickadd--info">' +
          '<a class="minicart__quickadd--name" href="' + url + '">' + title + '</a>' +
          '<span class="minicart__quickadd--price">' + formatMoney(price) + '</span>' +
          szHtml +
        '</div>' +
        '<button type="button" class="minicart__quickadd--add" data-quickadd-add' + disabledAttr + ' aria-label="Add ' + title + ' to cart">' + btnText + '</button>' +
      '</div>'
    );
  }

  async function handleTileAdd(tile, product) {
    var btn = tile.querySelector('[data-quickadd-add]');
    if (!btn || btn.disabled) return;
    var variantId = tile.getAttribute('data-selected-variant-id');
    if (!variantId) return;
    var szRow = tile.querySelector('.minicart__szrow');
    var szBtn = tile.querySelector('.chs__size');
    CHS.close(szRow);

    btn.disabled = true;
    if (szBtn) szBtn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = '...';

    try {
      await withBoosterSuppressed(function () {
        return postJSON('cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] });
      });
      state.addedProductIds[product.id] = true;
      btn.textContent = 'ADDED';
      tile.classList.add('is-added');
      await patchFromSection();
    } catch (e) {
      btn.disabled = false;
      if (szBtn) szBtn.disabled = false;
      btn.textContent = originalText;
    }
  }

  function wireTiles(row) {
    Array.prototype.slice.call(row.querySelectorAll('.minicart__quickadd--tile')).forEach(function (tile) {
      var szRow = tile.querySelector('.minicart__szrow');
      if (szRow) {
        CHS.wire(szRow, function (r, opt) {
          tile.setAttribute('data-selected-variant-id', opt.getAttribute('data-variant-id') || '');
        });
      }
      var btn = tile.querySelector('[data-quickadd-add]');
      if (!btn || btn.disabled) return;
      var productId = tile.getAttribute('data-product-id');
      var product = state.productsById[productId];
      if (!product) return;
      btn.addEventListener('click', function () { handleTileAdd(tile, product); });
    });
  }

  function renderRackInto(wrapper, ranked) {
    var row = wrapper.querySelector('[data-cart-quickadd-row]');
    if (!row) return;
    var html = ranked.map(function (product) {
      return renderTile(product, !!state.addedProductIds[product.id]);
    }).join('');
    row.innerHTML = html;
    wireTiles(row);
  }

  function repaintRackFromCache() {
    if (!state.ranked) return;
    getWrappers().forEach(function (wrapper) { renderRackInto(wrapper, state.ranked); });
  }

  async function computeAndRenderRack(cart) {
    var seenProductIds = {};
    var cartProductIds = [];
    cart.items.forEach(function (item) {
      if (!seenProductIds[item.product_id]) {
        seenProductIds[item.product_id] = true;
        cartProductIds.push(item.product_id);
      }
    });

    var resultSets = await Promise.all(cartProductIds.map(fetchRecommendations));

    var scores = {};
    var products = {};
    resultSets.forEach(function (list) {
      list.forEach(function (product) {
        if (seenProductIds[product.id]) return;
        if (!CHS.availableSizedVariants(product).length) return;
        scores[product.id] = (scores[product.id] || 0) + 1;
        products[product.id] = product;
      });
    });

    var ranked = Object.keys(scores)
      .sort(function (a, b) { return scores[b] - scores[a]; })
      .slice(0, TILE_LIMIT)
      .map(function (id) { return products[id]; });

    state.ranked = ranked;
    state.productsById = {};
    ranked.forEach(function (p) { state.productsById[p.id] = p; });

    // Render even when ranked is empty: wrapper is never hidden, unlike the prior build.
    getWrappers().forEach(function (wrapper) { renderRackInto(wrapper, ranked); });
  }

  async function onDrawerOpen() {
    var cart = await fetchCart();
    var isEmpty = !cart || !cart.items || !cart.items.length;
    state.cartEmpty = isEmpty;
    if (isEmpty) return;
    state.ranked = null;
    state.addedProductIds = {};
    await computeAndRenderRack(cart);
  }

  // Name kept from the select era. The control is now the shared button plus
  // menu built by ch-cart-size.js; the rows themselves are rendered by
  // api__minicart.liquid, so only the pick handler is supplied here.
  function wireLineSizeSelects(container) {
    Array.prototype.slice.call(container.querySelectorAll('.minicart__szrow[data-line-key]')).forEach(function (row) {
      CHS.wire(row, handleLineSizeChange);
    });
  }

  async function handleLineSizeChange(row, opt) {
    var lineKey = row.getAttribute('data-line-key');
    var qty = parseInt(row.getAttribute('data-line-qty'), 10) || 1;
    var newVariantId = opt.getAttribute('data-variant-id');
    var previousValue = row.getAttribute('data-current-value') || '';
    if (!newVariantId || newVariantId === previousValue) return;

    var szBtn = row.querySelector('[data-szbtn]');
    if (szBtn) szBtn.disabled = true;

    try {
      await withBoosterSuppressed(function () {
        return postJSON('cart/change.js', { id: lineKey, quantity: 0 }).then(function () {
          return postJSON('cart/add.js', { items: [{ id: Number(newVariantId), quantity: qty }] });
        });
      });
      await patchFromSection();
    } catch (e) {
      if (szBtn) szBtn.disabled = false;
    }
  }

  // 'booster:cart:update' fires BEFORE Booster applies its own DOM swap; a
  // macrotask defer guarantees this runs after [data-product-list] is replaced.
  function onBoosterCartUpdate() {
    setTimeout(async function () {
      var cart = await fetchCart();
      var isEmpty = !cart || !cart.items || !cart.items.length;
      var wasEmpty = state.cartEmpty;
      state.cartEmpty = isEmpty;

      getProductListEls().forEach(wireLineSizeSelects);

      if (isEmpty) return;
      if (wasEmpty) {
        state.ranked = null;
        state.addedProductIds = {};
        await computeAndRenderRack(cart);
        return;
      }
      repaintRackFromCache();
    }, 0);
  }

  function wireBoosterEvent(attemptsLeft) {
    var booster = getBoosterTheme();
    if (booster && booster.events && typeof booster.events.on === 'function') {
      booster.events.on('booster:cart:update', onBoosterCartUpdate);
      return;
    }
    if (attemptsLeft > 0) {
      setTimeout(function () { wireBoosterEvent(attemptsLeft - 1); }, 200);
    }
  }

  var wasOpen = false;

  function init() {
    // ch-cart-size.js is loaded first and both tags are defer, so this is only
    // ever null if that file failed to load. Bail rather than throw.
    if (!CHS) return;
    getProductListEls().forEach(wireLineSizeSelects);
    wireBoosterEvent(10);
    document.addEventListener('change', function (e) {
      var el = e.target;
      if (!el || !el.hasAttribute || !el.hasAttribute('data-minicart-input')) return;
      var open = anyDrawerOpen();
      if (open && !wasOpen) { onDrawerOpen(); }
      wasOpen = open;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
